import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-modal-pdfviewer',
  templateUrl: './modal-pdfviewer.component.html',
  styleUrls: ['./modal-pdfviewer.component.css']
})
export class ModalPDFViewerComponent implements AfterContentInit {
  @ViewChild('modalContainer2') modalContainer2?: ElementRef;
  private modal?: Modal;
  @Input() url: string = '';

  constructor() {}

  ngAfterContentInit(): void {
    this.initModal();
  }

  public showModal(url_: string) {

    this.url = url_;
    this.initModal();

    if(this.modal)
      this.modal.show();
  }
  public hideModal() {
    if(this.modal)
      this.modal.hide();
  }

  private initModal() {
    if (this.modalContainer2)
      this.modal = new Modal(this.modalContainer2?.nativeElement, {});
  }
}
